import OrderExternalIdUpdateRequest from "../../../api/raily/order/external-id-update/order-external-id-update-request";
import OrderExternalIdUpdateParams from "./order-external-id-update-params";

const create = (
  params: OrderExternalIdUpdateParams,
): OrderExternalIdUpdateRequest => {
  return {
    orderUuid: params.orderUuid,
    newExternalId: params.newExternalId,
  };
};

const orderExternalIdUpdateParamsFactory = { create };

export default orderExternalIdUpdateParamsFactory;
